/*
 * @Author: your name
 * @Date: 2020-12-03 08:55:17
 * @LastEditTime: 2021-06-09 17:00:47
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\components\mixins\track.js
 */
export default {
  data() {
    return {
      name: "mixin"
    };
  },
  created() { },
  mounted() {
    // let that = this;
    // this.$nextTick(() => {
    //     document.addEventListener("keyup", e => {
    //         if (e.keyCode == 27) {
    //             that.$refs.video.videoPop = false;
    //             document.body.style.overflow = "auto";
    //         }
    //     });
    // });
  },
  methods: {
    // 弹窗底部不允许滚动
    noScrollWindow(v) {
      var mo = function (e) {
        e.preventDefault()
      }
      if (v) {
        document.body.style.overflow = 'hidden' //出现滚动条
        document.addEventListener('touchmove', mo, false)
      } else {
        document.body.style.overflowY = ''
        document.removeEventListener('touchmove', mo, false)
      }
    },

    handleTrack(name) {
      // ;
      //let eventName = "导航_" + name;
      // let data = {
      //   c_userid: this.$store.getters.hsid,
      //   c_gender: "",
      //   i_age: "",
      //   c_other: {},
      //   c_pagename: "",
      //   c_event_info: name
      // };
      // let el = document.getElementsByClassName("drop-pannel")[0];
      // el ? (el.style.height = "0") : "";
      // hssdk_click(data);
    },
    goLogin(name) {
      this.handleTrack(name);
      localStorage.setItem("backUrl", window.location.href);
      this.$goLoginUrl();
    },
    handleProduct(list) {
      list.forEach(item => {
        if (item.service_keyword != "") {
          if (item.service_keyword == "," || item.service_keyword == "，") {
            item.service_keyword = [];
          } else {
            item.service_keyword = item.service_keyword.split(",");
          }
        }
        //1.API/H5/SAAS/SDK 展示峰值
        if (
          item.alternation_name == "API" ||
          item.alternation_name == "H5" ||
          item.alternation_name == "SAAS" ||
          item.alternation_name == "SDK"
        ) {
          item.showPeak = true;
        } else {
          item.showPeak = false;
        }
        //2.API/H5/SAAS/SDK 下载 人力 培训 展示次数
        if (
          item.alternation_name == "API" ||
          item.alternation_name == "H5" ||
          item.alternation_name == "SAAS" ||
          item.alternation_name == "SDK" ||
          item.alternation_name == "下载" ||
          item.alternation_name == "账号" ||
          item.alternation_name == "培训"
        ) {
          item.showInvokeTime = true;
        } else {
          item.showInvokeTime = false;
        }
        if (item.alternation_name == "下载") {
          item.invokeTimeUnit = "次数";
        }
        if (item.alternation_name == "人力") {
          item.invokeTimeUnit = "人数";
        }
        if (item.alternation_name == "账号") {
          item.invokeTimeUnit = "账号数";
        }
        if (item.alternation_name == "培训") {
          item.invokeTimeUnit = "人次";
        }
      });
    },
    solutionIn(e) {
      let dom = e.currentTarget.children[0].children[0];
      let name = dom.className,
        name1 = name.split(" ")[0],
        name2 = name.split(" ")[1];
      dom.className = name1 + " " + name1 + " " + "in";
    },
    solutionOut(e) {
      let dom = e.currentTarget.children[0].children[0];
      let name = dom.className,
        name1 = name.split(" ")[0],
        name2 = name.split(" ")[1];
      dom.className = name1 + " " + name1 + " " + "out";
    }
  }
};



// WEBPACK FOOTER //
// ./src/gtn/components/mixins/track.js